import { Link, animateScroll as scroll } from "react-scroll";

export default ({ src, srcWebp, textAlign }) => {
    return (
        <div className="relative">
            <div className="absolute left-0 h-full w-full">
                <picture>
                    <source
                        srcSet={srcWebp}
                        type="image/webp"
                        alt="Personal training locatie Uden en Schijndel"
                        className="w-full h-full object-cover"
                    />
                    <source
                        srcSet={src}
                        type="image/jpeg"
                        alt="Personal training locatie Uden en Schijndel"
                        className="w-full h-full object-cover"
                    />
                    <img
                        src={src}
                        alt="Personal training locatie Uden en Schijndel"
                        className="w-full h-full object-cover"
                    />
                </picture>
                <div
                    className="absolute inset-0 bg-gray-600 mix-blend-multiply"
                    aria-hidden="true"
                />
            </div>
            <div className="relative max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8 lg:py-48">
                <h3
                    className={`mt-2 text-white ${textAlign} font-extrabold font-custom uppercase italic tracking-tight  xs:text-3xl sm:text-3xl md:text-7xl lg:text-7xl`}
                >
                    Zet vandaag de stap <br /> naar jouw transformatie
                </h3>
                <div className="text-center">
                    <Link
                        to="contact"
                        smooth={true}
                        offset={0}
                        duration={800}
                        className="mt-12 uppercase ml-4 inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-white bg-we-are-purple focus:outline-none focus:ring-2 focus:ring-offset-2"
                    >
                        Plan een gesprek
                    </Link>
                </div>
            </div>
        </div>
    );
};
